import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import JSSidebar from './JSSidebar';
import Footer from '../element/Footer';
import NavBar from '../element/NavBar';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
// mui
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadRoundedIcon from '@mui/icons-material/FileDownloadRounded';

const JSAppliedJobs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const userType = Cookies.get('user_type');
  const tokenKey = Cookies.get('tokenClient');

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedJobs, setAppliedJobs] = useState([]);

  const jobsPerPage = 10;

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;

  const currentData = appliedJobs
    ? appliedJobs.slice(indexOfFirstJob, indexOfLastJob)
    : appliedJobs.slice(indexOfFirstJob, indexOfLastJob);

  const handlePageChange = pageNumber => setCurrentPage(pageNumber);

  const translateStatus = status => {
    const translations = {
      new: t('employerInnerAccountdetail.new'),
      offer: t('employerInnerAccountdetail.offer'),
      accept: t('employerInnerAccountdetail.accept'),
      reviewed: t('employerInnerAccountdetail.reviewed'),
      interview: t('employerInnerAccountdetail.interview'),
      short_list: t('employerInnerAccountdetail.shortlist'),
      not_suitable: t('employerInnerAccountdetail.notSuitable'),
    };

    return translations[status] || '';
  };

  const getData = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        BaseApi + '/job/applied',
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        setLoading(false);
        setAppliedJobs(response.data.response.jobApplyed);
      }

      if (response.data.status === 400) {
        navigate('/');
        setLoading(false);

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('searchJobPage.close'));
      }

    } catch (error) {
      setLoading(false);

      if (error.message === 'Network Error' || error.response.data.message === 'Token has expired') {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error('Cannot get applied jobs data', error);
    }
  };

  const handleFileDownload = async (e, id) => {
    e.preventDefault();

    try {
      const response = await axios.get(
        BaseApi + `/jobApply/downloadFile/${id}`,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
          responseType: 'blob',
        },
      );

      const url = window.URL.createObjectURL(response.data);
      const filename = response.headers['content-disposition'].split('filename=')[1];

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename.replace(/['"]/g, ''));
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);

      getData();
    } catch (error) {
      console.error('Could not download file:', error);

      Swal.fire({
        icon: 'error',
        confirmButtonText: t('employerInnerAccountdetail.close'),
        title: t('employerFavouriteListProfile.fileDownloadFailedTitle'),
      });
    }
  };

  useEffect(() => {
    if (userType === 'recruiter' || !tokenKey) {
      navigate('/user/jobseekerlogin');
    } else {
      getData();
      window.scrollTo(0, 0);
    }
  }, [tokenKey, navigate, userType]); // eslint-disable-line

  return (
    <>
      <NavBar />
      <div className='container paymentHistory'>
        <div className='row'>
          <div className='col-lg-3 col-md-3'>
            <JSSidebar />
          </div>
          {
            loading
              ? (
                <div className='loader-container'></div>
              ) : (
                <div className='col-lg-9 col-md-9 mb-5'>
                  <div className='PHHeader'>
                    <div className='d-flex align-items-center PageHeader'>
                      <img
                        alt=''
                        src='/Images/jobseekerSide/Applied-Jobs-color.png'
                      />
                      <h3 className='ms-2' style={{ color: '#8cbcdc' }}>
                        {t('jobseekerAppliedJobs.appliedJobs')}
                      </h3>
                    </div>
                    <div className='PHBody mt-5'>
                      <table className='table'>
                        <thead>
                          <tr className='table-active TrFirst'>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.SNo.')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.jobTitle')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.companyName')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.appliedDate')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.status')}
                            </th>
                            <th className='' scope='col p-3'>
                              {t('jobseekerAppliedJobs.review')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            currentData.map((i, index) => (
                              <tr key={index} className='TrDefoult rightSide'>
                                <td className=''>{index + 1}</td>
                                <td className=''>{i.title}</td>
                                <td className=''>{i.company_name}</td>
                                <td className=''>{i.created}</td>
                                <td className=''>{translateStatus(i.status)}</td>
                                <td className='jobApplyType'>
                                  {
                                    i.jobApplyType.type === 'cv' && (
                                      <div>
                                        <Link to={`/candidates/my-cv-list/${i.jobApplyType.id}`}>
                                          <VisibilityIcon sx={{ mr: '6px' }} />
                                          {t('employerInnerAccountdetail.view')}
                                        </Link>
                                        <p>{t('employerInnerAccountdetail.cv')}</p>
                                      </div>
                                    )
                                  }
                                  {
                                    i.jobApplyType.type === 'questionary' && (
                                      <div>
                                        <Link to={`/candidates/questionnaire/${i.jobApplyType.id}`}>
                                          <VisibilityIcon sx={{ mr: '6px' }} />
                                          {t('employerInnerAccountdetail.view')}
                                        </Link>
                                        <p>{t('employerInnerAccountdetail.questionnaire')}</p>
                                      </div>
                                    )
                                  }
                                  {
                                    i.jobApplyType.type === 'file' && (
                                      <div>
                                        <a href='#' onClick={e => handleFileDownload(e, i.jobApplyType.id)}>
                                          <FileDownloadRoundedIcon sx={{ mr: '6px' }} />
                                          {t('employerInnerAccountdetail.download')}
                                        </a>
                                        <p>{t('employerInnerAccountdetail.file')}</p>
                                      </div>
                                    )
                                  }
                                </td>
                              </tr>
                            ))
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='JSAppliedJobsPagination'>
                    <p className='text-muted empPaginationData'>
                      {t('pagination.NoofRecords')} {appliedJobs.length > 0 ? indexOfFirstJob + 1 : indexOfFirstJob}-
                      {Math.min(indexOfLastJob, appliedJobs.length)} of{' '}
                      {appliedJobs ? appliedJobs.length : appliedJobs.length}
                    </p>
                    <div className='d-flex justify-content-center empPaginationButton'>
                      <button
                        className='navButton1 me-2'
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                      >
                        {t('pagination.Prev')}
                      </button>
                      <button
                        className='navButton1'
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={
                          appliedJobs
                            ? indexOfLastJob >= appliedJobs.length
                            : indexOfLastJob >= appliedJobs.length
                        }
                      >
                        {t('pagination.Next')}
                      </button>
                    </div>
                  </div>
                </div>
              )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default JSAppliedJobs;
